import { useAuth } from '@/store/useAuth';
import * as Sentry from '@sentry/react';

type Details = {
    channel: string;
    chat?: string | number;
};

export const useLogProfileChannelRejection = () => {
    const userData = useAuth((state) => state.getUser());
    
    const logProfileChannelRejection = (details: Details) => {
        return Sentry.captureMessage('Subscription is rejected', {
            extra: { user: userData?.id, ...details }
        });
    }

    return { logProfileChannelRejection }
}
